import { useEffect } from 'react';

const BASE_TITLE = 'MaTaxPreparer | MA Tax Preparer LLC';

const usePageTitle = (pageTitle) => {
  useEffect(() => {
    const previousTitle = document.title;
    
    if (pageTitle) {
      document.title = `${pageTitle} | ${BASE_TITLE}`;
    } else {
      document.title = BASE_TITLE;
    }
    
    return () => {
      document.title = previousTitle;
    };
  }, [pageTitle]);
};

export default usePageTitle;
